var map = {
	"./accenture-logo.png": 101,
	"./bir-logo.png": 102,
	"./icefox-logo.png": 103,
	"./julles.jpg": 46,
	"./multisys-logo.png": 104,
	"./udemy-certificate.PNG": 105,
	"./udemy-logo.png": 106,
	"./ust-logo.png": 44,
	"./zuitt-logo.png": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;